import { CommonHelperFunctions, INotificationTemplateDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

// The backend re-homes Unlayer-hosted template images onto our own /resource storage on save, and
// must address them at the API host the browser actually uses. Only the frontend reliably knows
// that host, so send its origin (scheme+host, without the /v1/api path) on create/update.
const getResourceBaseOrigin = (): string => {
  try {
    return new URL(backendUrl).origin;
  } catch {
    return backendUrl;
  }
};
const resourceBaseUrlHeaders: Record<string, string> = { "X-Kuika-Resource-Base-Url": getResourceBaseOrigin() };

export class NotificationTemplateService {
  public static async Create(template: INotificationTemplateDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<INotificationTemplateDto, AxiosResponse>(
        `${backendUrl}/NotificationTemplate/create`,
        template,
        { headers: resourceBaseUrlHeaders }
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async CreateByTemplateId(
    templateid: string,
    templatename: string,
    projectid: string
  ): Promise<AxiosResponse> {
    try {
      const data = {
        projectId: projectid,
        templateId: templateid,
        templateName: templateid
      };
      return await Axios.post<INotificationTemplateDto, AxiosResponse>(
        `${backendUrl}/NotificationTemplate/addTemplateByTemplateID/${templateid}/${projectid}/${templatename}`
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetNotificationTemplates(projectId: string): Promise<AxiosResponse> {
    try {
      return await Axios.get<string, AxiosResponse>(
        `${backendUrl}/NotificationTemplate/getallbyprojectid/${projectId}`
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetNotificationTemplateFromUnlayer(temmpateCode: string): Promise<AxiosResponse> {
    try {
      const req = {
        operationName: "StockTemplateLoad",
        variables: { slug: temmpateCode },
        query:
          "query StockTemplateLoad($slug: String!) {\n  StockTemplate(slug: $slug) {\n    id\n    name\n    design\n    usage\n    industry\n    tags\n    premium\n    rating\n    votes\n    StockTemplatePages {\n      id\n      name\n      design\n      html\n      position\n      __typename\n    }\n    __typename\n  }\n}"
      };
      return await Axios.post<INotificationTemplateDto, AxiosResponse>("https://api.graphql.unlayer.com/graphql", req);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Delete(id: string, projectId: string): Promise<AxiosResponse> {
    try {
      const res = await Axios.delete<null>(`${backendUrl}/NotificationTemplate/${id}/${projectId}`);
      return res;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Update(
    id: string,
    template: INotificationTemplateDto,
    updateWithoutValidation?: boolean
  ): Promise<boolean> {
    try {
      await Axios.put<INotificationTemplateDto, INotificationTemplateDto>(
        `${backendUrl}/NotificationTemplate/${id}`,
        template,
        {
          params: {
            updateWithoutValidation: updateWithoutValidation ?? false
          },
          headers: resourceBaseUrlHeaders
        }
      );
      return true;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async Duplicate(obj: any): Promise<AxiosResponse> {
    try {
      return await Axios.post<null>(`${backendUrl}/NotificationTemplate/duplicate/`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  // public static async GetById(id: string, projectId: string): Promise<AxiosResponse> {
  //     try{
  //         return Axios.get<string, AxiosResponse>(backendUrl + "/NotificationTemplate/getById/" + id + "/" + projectId);
  //     }
  //     catch (error: any) {
  //         KMainFunctions.exceptionHandler(error);
  //         return error;
  //     }
  // }
}
